import AuthComponent from './AuthComponent';
import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  navigate,
  useLocation,
  Navigate,
  useNavigate,
  NavLink
} from "react-router-dom";
import './App.css';
import './mobile-responsive.css';
import TickerForm from './TickerForm';
import prideFlagImage from "./images/pride-flag.png";
import Swiping from './pages/swiping';
import Learn from './pages/learn';
import SignUpPage from './pages/signuppage';
import SignInPage from './pages/signinpage';
import { ForgotPasswordPage, ResetPasswordPage } from './pages/PasswordReset';
import SignedOutFeature from './components/SignedOutFeature';
import PortfolioDisplayPage from './pages/PortfolioDisplayPage';
import OrderHistory from './pages/orderhistory.js';
import StockPurchase from './pages/stockpurchase';
import StockPage from './pages/StockPage';
import SearchBar from './pages/SearchBar';
import Tournaments from './pages/Tournaments';
import Lab from './pages/Lab';
import SignOut from './components/SignOut';
import { useUser} from './context/UserContext';
import UserContext from './context/UserContext';
import Charts from './pages/charts.js';
import Dashboard from './pages/dashboard.js';
import CoursePage from './pages/courses.js';
import Articles from './pages/Articles.js';
import Scanner from './pages/scanner.js';
import SearchResults from './pages/SearchResults.js';
import AccountPage from './pages/accountpage.js';
import Settings from './pages/settings.js';
import Battleship from './pages/battleship.js';
import Test from './pages/test.js';
import { apiClient, AUTH_INVALID_EVENT } from './api/client';
import { getAuthToken } from './auth/authStorage';
import { validateSession } from './api/auth';
import minilogo from './images/mini-logo.png';
import acct from './images/account-pic.png';
import lout from './images/logout-pic.png';
import beta from './images/beta-img.png';
import soon from './images/soon-img.png';
import logoutI from './images/LogoutIMG.png';
import controlPanelImage from './images/control-panel.png';
import chevronRight2Image from './images/chevron-right-2.svg';
import chevronRight2ImageW from './images/chevron-right-2white.svg';
import investmentPortfolioImage from './images/investment-portfolio.png';
import newsImage from './images/news.png';
import calendarImage from './images/calendar.png';
import messageQuestion1Image from './images/message-question-1.svg';
import ellipse8Image from './images/ellipse-8.svg';
import chevronDown2Image from './images/chevron-down-2.svg';
import funnel from './images/funnel.png';
import kopiaStockSleuthImage from './images/Kopia_STOCK_SLEUTH-removebg-preview-1.png';
import './newstyles.css';
import leftArrow from './images/left-arrow.png';
import rightArrow from './images/right-arrow.png';
import swipe from './images/swipe.png';
import podium from './images/leaderboard.png';
import swipeW from './images/swipew.png';
import podiumW from './images/leaderboardw.png';
import controlPanelImageW from './images/Control-PanelW.png';
import investmentPortfolioImageW from './images/investment-portfolioW.png';
import newsImageW from './images/NewsW.png';

import book from './images/Book.png';
import bookW from './images/BookW.png';
import calendarImageW from './images/CalendarW.png';
import chevronDownW from './images/chevron-downW.png';
import funnelG from './images/funnelG.png';
import flask from './images/flask.png';
import flaskw from './images/flaskW.png';
import ProfilePage from './pages/ProfilePage';
import { PrivacyPolicy, TermsOfService, CookiePolicy, AiTransparency } from './pages/LegalPages.js';
import NotificationBell from './components/NotificationBell';
import CookieConsent, { Cookies, getCookieConsentValue  } from "react-cookie-consent";
import ReactGA from "react-ga4";
import { useLanguage } from './context/LanguageContext';
import usFlag from './images/us.png';
import plFlag from './images/pl.png';
//ReactGA.initialize("G-FJDF97RPHE");
const StockPageWrapper = ({ scrollRootRef }) => {
  const { ticker } = useParams();
  return <StockPage key={ticker} scrollRootRef={scrollRootRef} />;
};

function App() {
  const { language, setLanguage, t } = useLanguage();
  const [languageOpen, setLanguageOpen] = useState(false);
  const languageRef = useRef(null);
  const { setUser } = useContext(UserContext);
  const { user, isLoggedIn, logout } = useUser();
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState('dashboard');
  const [isTournamentsPage, setIsTournamentsPage] = useState(true);
  const [disname, setDisname] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isCompactDesktop, setIsCompactDesktop] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1366
  );
  const [authReady, setAuthReady] = useState(false);
  const location = useLocation();
  const [analyticsConsent, setAnalyticsConsent] = useState(() => getCookieConsentValue("gdpr") === "true");
  const [consentRecorded, setConsentRecorded] = useState(() => getCookieConsentValue("gdpr") !== undefined);
  const [consentBannerKey, setConsentBannerKey] = useState(0);
  useEffect(() => {
    const closeMenu = (event) => {
      if (!languageRef.current?.contains(event.target)) setLanguageOpen(false);
    };
    document.addEventListener('mousedown', closeMenu);
    return () => document.removeEventListener('mousedown', closeMenu);
  }, []);
  useEffect(() => {
	console.log("runs");
  const handleResize = () => {
	console.log("handling");
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    setIsCompactDesktop(window.innerWidth > 768 && window.innerWidth <= 1366);
    if (mobile) {
		console.log("mobile");
      setIsSidebarVisible(false);
    } else {
	  console.log("desktop");
	  setIsSidebarVisible(true);
	}
  };

  // Invoke handleResize on component mount
  handleResize();

  // Add event listener for window resize
  window.addEventListener('resize', handleResize);

  // Cleanup event listener on component unmount
  return () => window.removeEventListener('resize', handleResize);
}, []);
  const sidebarWidth = isCompactDesktop ? 220 : 306;

  const [currentLocation, setCurrentLocation] = useState('');
	const isPortfolio = location.pathname === '/Portfolio' || location.pathname === '/OrderHistory' || location.pathname === '/BuyStocks';
	const normalizedAuthPath = location.pathname.replace(/\/+$/, '').toLowerCase();
	const UserLog = ['/signin', '/signup', '/forgotpassword', '/forgot-password', '/resetpassword', '/reset-password', '/password-reset'].includes(normalizedAuthPath);
	const initialized = useRef(false);
//<img src={logoutI} onClick={handleSignOut} style={{bottom: "5px", left: "220px", width: "38px", height: "38px", position: "absolute"}}/>

	useEffect(() => {
		const pageTitles = {
		  '/dashboard': 'Dashboard - Stock Sleuth',
		  '/portfolio': 'Portfolio - Stock Sleuth',
		  '/scanner': 'Stock Scanner - Stock Sleuth',
		  '/account': 'Account - Stock Sleuth',
		  '/signIn': 'Sign In - Stock Sleuth',
		  '/signUp': 'Sign Up - Stock Sleuth',
		  '/':'Home'
		};
	
		document.title = pageTitles[location.pathname] || location.pathname;
	  }, [location.pathname]);

  const handleLogoClick = () => {
    // Navigate to the "/dashboard" route
    navigate('/');
  };


  
  useEffect(() => {
    if (!analyticsConsent) return;
    if (!initialized.current) {
      ReactGA.initialize("G-FJDF97RPHE", { gaOptions: { anonymizeIp: true } });
      initialized.current = true;
    }
    ReactGA.send({ hitType: "pageview", page: `${location.pathname}${location.search}` });
  }, [analyticsConsent, location.pathname, location.search]);


  useEffect(() => {
    // Check if the current pathname is /Tournaments
    if (location.pathname === '/Tournaments') {
      setIsTournamentsPage(true);
	  

    } else {
      setIsTournamentsPage(false);
	  //setIsSidebarVisible(true);
    }
  }, [location.pathname]);
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };
  useEffect(() => {
    const checkAuthentication = async () => {
      const authToken = getAuthToken();
      if (authToken) {
		try {
			  const response = await validateSession();
			  const user = response.data.user;

			  // Fetch the profile image separately
			  const profileImageResponse = await apiClient.get('/auth/getpfp');

			  // Add the profile_image field to the user object
			  const updatedUser = {
          ...response.data, ...response.data.username, ...response.data.image,
				profile_image: profileImageResponse.data.profile_image,
				displayname: profileImageResponse.data.displayname,
				pronouns: profileImageResponse.data.pronouns,
        username: profileImageResponse.data.username,
				bio: profileImageResponse.data.bio,
				mod: profileImageResponse.data.mod,
				premium: profileImageResponse.data.premium,
        language: profileImageResponse.data.language,
        earningsEmailEnabled: Boolean(profileImageResponse.data.earningsEmailEnabled),
			  };
			  setDisname(profileImageResponse.data.displayname);
			  setUser(updatedUser);
			} catch (error) {
          // The interceptor clears invalid credentials; do not expose backend details.
          // If token validation fails, you might want to remove the invalid token from cookies
          logout();
        }
      }
      setAuthReady(true);
    };

    checkAuthentication();
  }, [setUser, logout]);

  useEffect(() => {
    const handleInvalidAuth = () => {
      logout();
    };
    window.addEventListener(AUTH_INVALID_EVENT, handleInvalidAuth);
    return () => window.removeEventListener(AUTH_INVALID_EVENT, handleInvalidAuth);
  }, [logout]);
  
  
const scrollRef = useRef(null);
  useEffect(() => {
    // Update the current location when the route changes
    setCurrentLocation(location.pathname);
  }, [location.pathname]);
  const handleSignOut = async () => {
    try {
      // Make an API request to the logout endpoint in your Node.js backend running locally
      await apiClient.post('/auth/logout');
      logout();
      // Once logged out, set the user in the context to null
      setUser(null);
	  logout();
	  navigate('/SignIn');
    } catch (error) {
      // Local logout must succeed even when the server is unavailable.
    } finally {
      logout();
      setUser(null);
      navigate('/SignIn');
    }
  };
  const goToAccount = () => {
    // Navigate to the /account route when the image or text is clicked
    navigate('/account');
  };
  
  
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  
  const removeAnalyticsCookies = useCallback(() => {
    Object.keys(Cookies.get()).filter((name) => name === "_ga" || name.startsWith("_ga_")).forEach((name) => Cookies.remove(name, { path: "/" }));
  }, []);
  const handleCookieAccept = useCallback(() => { setAnalyticsConsent(true); setConsentRecorded(true); }, []);
  const handleCookieDecline = useCallback(() => { setAnalyticsConsent(false); setConsentRecorded(true); removeAnalyticsCookies(); }, [removeAnalyticsCookies]);
  const handleCustomize = useCallback(() => {
    Cookies.remove("gdpr", { path: "/" });
    removeAnalyticsCookies();
    setAnalyticsConsent(false);
    setConsentRecorded(false);
    setConsentBannerKey((value) => value + 1);
  }, [removeAnalyticsCookies]);

  return (
	
    <div className="App">
<div className="whole" style={{height: '100vh'}}>
<CookieConsent
  key={consentBannerKey}
  location="bottom"
  buttonText="Accept analytics"
  enableDeclineButton
  style={{ background: "white", color: "black", alignContent: "center", right: "0px", width: "40%", maxWidth: "550px", left: "none", flexWrap: "nowrap", marginBottom: 40, marginRight: 40, borderRadius: 30,
	alignItems: "center",
    flexDirection: "column",
    justifyContent: "flex-start", boxShadow: "0px 10px 60px rgb(109 111 113 / 33%)"}}
  buttonStyle={{ fontFamily: "Lexend", marginBottom: 50, color: "white", fontSize: "15px", backgroundColor: "#5830b6", padding: "16px 24px 16px 24px", borderRadius: 20}}
  contentStyle={{
	width: "70%",
	paddingLeft: 20,
	paddingRight: 20,
	paddingTop: 20,
	flex: "none",
	
  }}
  declineButtonText="Reject analytics"
  declineButtonStyle={{ fontFamily: "Lexend", marginBottom: 50, color: "#5830b6", fontSize: "15px", backgroundColor: "white", padding: "16px 24px 16px 24px", borderWidth: 2, borderRadius: 20, border: "2px solid #5830b6"}}
  expires={365}
  cookieName="gdpr"
  onAccept={handleCookieAccept}
  onDecline={handleCookieDecline}
  //ButtonComponent={CustomizeButton}
>
<strong style={{marginBottom: 16}}>Your privacy choices</strong><br/>
We use necessary storage to run StockSleuth. With your permission, Google Analytics helps us understand usage. Rejecting analytics will not limit core features. Read our <a style={{color: "#5830b6", textDecoration: "underline"}} href="/cookies">Cookie Policy</a> and <a style={{color: "#5830b6", textDecoration: "underline"}} href="/privacy">Privacy Policy</a>.

</CookieConsent>
{consentRecorded && <button type="button" onClick={handleCustomize} style={{ position: "fixed", zIndex: 1000, right: 14, bottom: 12, border: "1px solid #d7d2e5", borderRadius: 9, background: "#fff", color: "#595166", padding: "7px 10px", fontFamily: "Poppins, sans-serif", fontSize: 10, cursor: "pointer" }}>Cookie settings</button>}

		
	  {!UserLog ? (
	  <div>
		  
		<div className={`box ${isSidebarVisible && !isMobile ? 'box-visible' : 'box-hidden'}`}>
      <div className="side-menu">
	  <div className="sidebar-content">
        <div className="overlap">
		
		<div className="container">
			
          <NavLink to="/dashboard" className="dashboard sidebar-item" activeClassName="active-link">
		  {currentLocation === '/dashboard' || currentLocation === '/' ? (<>
				<div className="overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="Control panel" src={controlPanelImageW} />
				<div className="text-wrapper"style={{ color: '#FFFFFF' }}>Dashboard</div>
				</div></div></>
				
			  ) : (<>
				<div className="white-overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="Control panel" src={controlPanelImage} />
				<div className="text-wrapper">Dashboard</div>
				</div></div></>
			  )}
			
          </NavLink>
		  
          <NavLink to="/portfolio" className={`sidebar-item dashboard ${isDropdownOpen ? 'open' : ''}`}>
			  {currentLocation === '/portfolio' ? (<>
				<div className="overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="Investment portfolio" src={investmentPortfolioImageW} />
				<div style={{ color: '#FFFFFF' }} className="text-wrapper">Portfolio</div>
			</div>
            </div>
			  </>) : (<>
				<div className="white-overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
			<img className="img" alt="Investment portfolio" src={investmentPortfolioImage} />
				<div className="text-wrapper">Portfolio</div>
				
				</div>
			
            </div>
			  </>)}
			
          </NavLink>
		  
          <NavLink to="/scanner" className="dashboard sidebar-item" activeClassName="active-link">
		  {currentLocation === '/scanner' || currentLocation.startsWith('/stock/') ? (
				<div className="overlap-group">
									<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>

					<img className="img" alt="Funnel" src={funnel} />
				<div className="text-wrapper" style={{ color: '#FFFFFF' }}>Scanner</div></div>
				
				
				</div>
			  ) : (
				<div className="white-overlap-group">
									<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>

					<img className="img" alt="Funnel" src={funnelG} />
				<div className="text-wrapper" >Scanner</div></div>
				
				
				</div>
			  )}
            
			
          </NavLink>
          <NavLink to="/lab" className="dashboard sidebar-item" activeClassName="active-link">
		  {currentLocation === '/lab' ? (
				<div className="overlap-group">
									<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>

					<img className="img" alt="Flask" src={flaskw} />
				<div className="text-wrapper" style={{ color: '#FFFFFF' }}>Lab</div></div>
				
				
				</div>
			  ) : (
				<div className="white-overlap-group">
									<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>

					<img className="img" alt="Flask" src={flask} />
				<div className="text-wrapper" >Lab</div></div>
				
				
				</div>
			  )}
            
			
          </NavLink>
		  
          {/* <NavLink to="/Tournaments" className="dashboard active sidebar-item" activeClassName="active-link">
		  {currentLocation === '/Tournaments' ? (<>
				<div className="overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="Tournaments" src={podiumW} />
            <div className="text-wrapper" style={{ color: '#FFFFFF' }}>Tournaments</div>
            <p className="text-wrapper"  style={{
  position: 'relative',
  alignSelf: 'flex-end',
  backgroundColor: '#7c7cff80',
  color: '#fff',
  borderRadius: '4px',
  padding: '4px',
}}>Soon</p>
            </div>
			</div>
			  </>) : (<>
				<div className="white-overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="News" src={podium} />
            <div className="text-wrapper" >Tournaments</div>
            <p className="text-wrapper"  style={{
  position: 'relative',
  alignSelf: 'flex-end',
  backgroundColor: '#7c7cff80',
  color: '#fff',
  borderRadius: '4px',
  padding: '4px',
}}>Soon</p>
            
			</div></div>
			  </>)}
			
          </NavLink> */}
		  
          <NavLink to="/swipe" className="dashboard sidebar-item" activeClassName="active-link">
		  {currentLocation === '/swipe' ? (<>
				<div className="overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="Calendar" src={swipeW} />
				<div className="text-wrapper" style={{ color: '#FFFFFF' }}>Swipe</div>
				<p className="text-wrapper"  style={{
  position: 'relative',
  alignSelf: 'flex-end',
  backgroundColor: 'rgb(96 188 55 / 50%)',
  color: '#fff',
  borderRadius: '4px',
  padding: '4px',
}}>Beta</p>
				</div></div>
			  </>) : (<>
				<div className="white-overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="Calendar" src={swipe} /><div className="text-wrapper">Swipe</div>
				<p className="text-wrapper"  style={{
  position: 'relative',
  alignSelf: 'flex-end',
  backgroundColor: 'rgb(96 188 55 / 50%)',
  color: '#fff',
  borderRadius: '4px',
  padding: '4px',
}}>Beta</p>
				</div></div>
			  </>)}
			
          </NavLink>

		  <NavLink to="/learn" className="dashboard sidebar-item" activeClassName="active-link">
		  {currentLocation === '/learn' || currentLocation.startsWith('/courses/') ? (<>
				<div className="overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="Calendar" src={bookW} />
				<div className="text-wrapper" style={{ color: '#FFFFFF' }}>Learn</div>
				
				</div></div>
			  </>) : (<>
				<div className="white-overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
				<img className="img" alt="Calendar" src={book} /><div className="text-wrapper">Learn</div>
				
				</div></div>
			  </>)}
			
          </NavLink>

		  <NavLink to="/help" className="dashboard sidebar-item" activeClassName="active-link ">
			<div className="white-overlap-group">
				<div style={{display: "flex", justifyContent: "flex-start", width: "100%", paddingLeft: 14, paddingRight: 14, alignItems: "center"}}>
            <img style={{width: "26px", height: '26px'}} className="img" alt="Help" src={messageQuestion1Image} />
            <div className="text-wrapper">Help</div>
            </div>
			</div>
          </NavLink>
		  
		  </div>
		  {isLoggedIn ? (<>
          <NavLink to="/account" className="account" activeClassName="active-link">
            <div className="overlap-2">
              <div className="text-wrapper-4">{user?.displayname || ''}</div>
              <div className="text-wrapper-5">Your Account</div>
            </div>
			
			<div
	style={{
            width: '42px', // Adjust the width and height as needed
            height: '42px',
            borderRadius: '50%', // This makes the container circular
            overflow: 'hidden', // This ensures the image stays within the circular container
          }}
        >
			
          {user && user.profile_image ? (
    <img
      src={`data:image/jpeg;base64,${user.profile_image}`} // Use user.profile_image directly
      alt="pfp"
      style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: "8px" }}
    />
	
  ) : (
    <></>
  )}
        </div>
			
			
            
            
          </NavLink></>) : (<>
			<NavLink to="/SignIn" style={{}} className='loginbuttonbottom'>
				Log In
				</NavLink>
		  </>)}
		  
          <img className="chevron-down" alt="Chevron down" src={chevronDown2Image} />
          <div className="overlap-4">
  <NavLink to="/" className="logo">
    <div className="overlap-5">
      <div className="text-wrapper-7">
        StockSleuth
      </div>
      <img
        className="kopia-STOCK-SLEUTH"
        alt="Kopia STOCK SLEUTH"
        src={kopiaStockSleuthImage}
      />
    </div>
  </NavLink>

   <div className="text-wrapper-8">v.01</div>
{/*
  <img
    className="text-wrapper-899 logo-pride-flag"
    src={prideFlagImage}
    alt="Pride flag"
  /> */}
</div>
        </div>
		</div>

      </div>
    </div>
	<div
  className="mobile-overlay"
  style={{
    display: isSidebarVisible && isMobile ? 'flex' : 'none',
    position: 'fixed',
    top: '64px',
    bottom: 0,
    left: 0,
    width: '100vw',
    backgroundColor: '#fff',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
	padding: '20px',
	    zIndex: 50,
    overflow: 'hidden',
  }}
>
  <NavLink style={({ isActive }) => ({
  color: isActive ? '#5830b6' : '#333',
  fontWeight: isActive ? '600' : 'normal',
  textDecoration: 'none',
  margin: '10px 0',
})} to="/dashboard" className="simple-link" onClick={() => setIsSidebarVisible(false)}>Dashboard</NavLink>
  <NavLink style={({ isActive }) => ({
  color: isActive ? '#5830b6' : '#333',
  fontWeight: isActive ? '600' : 'normal',
  textDecoration: 'none',
  margin: '10px 0',
})} to="/portfolio" className="simple-link" onClick={() => setIsSidebarVisible(false)}>Portfolio</NavLink>
  <NavLink style={({ isActive }) => ({
  color: isActive ? '#5830b6' : '#333',
  fontWeight: isActive ? '600' : 'normal',
  textDecoration: 'none',
  margin: '10px 0',
})} to="/scanner" className="simple-link" onClick={() => setIsSidebarVisible(false)}>Scanner</NavLink>
  {/* <NavLink style={({ isActive }) => ({
  color: isActive ? '#5830b6' : '#333',
  fontWeight: isActive ? '600' : 'normal',
  textDecoration: 'none',
  margin: '10px 0',
})} to="/Tournaments" className="simple-link" onClick={() => setIsSidebarVisible(false)}>Tournaments</NavLink> */}
  <NavLink style={({ isActive }) => ({
  color: isActive ? '#5830b6' : '#333',
  fontWeight: isActive ? '600' : 'normal',
  textDecoration: 'none',
  margin: '10px 0',
})} to="/swipe" className="simple-link" onClick={() => setIsSidebarVisible(false)}>Swipe</NavLink>
  <NavLink style={({ isActive }) => ({
  color: isActive ? '#5830b6' : '#333',
  fontWeight: isActive ? '600' : 'normal',
  textDecoration: 'none',
  margin: '10px 0',
})} to="/learn" className="simple-link" onClick={() => setIsSidebarVisible(false)}>Learn</NavLink>
  <NavLink style={({ isActive }) => ({
  color: isActive ? '#5830b6' : '#333',
  fontWeight: isActive ? '600' : 'normal',
  textDecoration: 'none',
  margin: '10px 0',
})} to="/help" className="simple-link" onClick={() => setIsSidebarVisible(false)}>Help</NavLink>
</div>

	<div className='topNavBar' style={{left: isSidebarVisible && !isMobile ? sidebarWidth+1 : 0}}>
		<div className='HideSidebar' onClick={() => setIsSidebarVisible((prev) => !prev)} onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e0e0e0")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0)")}>
	<svg fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="black"  width="25" height="25">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"></path>
</svg></div>
		<SearchBar
      onNavigate={() => {
        if (isMobile) setIsSidebarVisible(false);
      }}
    />
		{isLoggedIn  ? (<> {!isMobile && (<><div className="language-picker" ref={languageRef}>
      <button className="language-button" type="button" onClick={() => setLanguageOpen((open) => !open)} aria-label={t('Language')} aria-expanded={languageOpen}>
        <img src={language === 'pl' ? plFlag : usFlag} alt={language === 'pl' ? 'Polski' : 'English'} />
      </button>
      {languageOpen && <div className="language-dropdown" role="menu">
        <button type="button" className={language === 'en' ? 'selected' : ''} onClick={() => { setLanguage('en'); setLanguageOpen(false); }}><img src={usFlag} alt="" /> English</button>
        <button type="button" className={language === 'pl' ? 'selected' : ''} onClick={() => { setLanguage('pl'); setLanguageOpen(false); }}><img src={plFlag} alt="" /> Polski</button>
      </div>}
    </div></>)}

    <NotificationBell enabled={isLoggedIn} />


		<div
          style={{
            
          }}
		  className='pfpTop'
        >
			
          {user && user.profile_image ? (<NavLink to="/account">
    <img
      src={`data:image/jpeg;base64,${user.profile_image}`} // Use user.profile_image directly
      alt="pfp"
	  
      style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: "8px"}}
    /></NavLink>
	
  ) : (
    <></>
  )}
        </div></>) : (
			<>
			<div style={{position: "absolute", right: !isMobile ? 20 : 0, display: "flex", gap: 10, width: !isMobile ? 170 : 'auto'}}>
				<NavLink to="/SignIn" style={{flex: 1}} className={!isMobile ? 'loginbuttons' : 'loginbuttonsMobile'}>
				Log In
				</NavLink>
        {!isMobile && (
				<NavLink to="/SignUp" style={{flex: 1}} className='loginbuttons'>
					Sign Up
				</NavLink>)}
				</div>
			</>
		)}
	</div>
	
	</div>
	  ) : (
        <div>
		
        </div>
      )}
	  
	  
	  
		{UserLog ? (
		<div className="content" style={{
			height: "100vh",
			alignItems: "center",
			justifyContent: "center",
			textAlign: "center",
			left: "0px",
			top: '0px',
			width:'100%',
			position: 'fixed'
			
		}}>
		<Routes>
		<Route path="/SignIn" element={<SignInPage />} />
		<Route path="/SignUp" element={<SignUpPage />} />
		<Route path="/ForgotPassword" element={<ForgotPasswordPage />} />
		<Route path="/ResetPassword" element={<ResetPasswordPage />} />
		<Route path="/reset-password" element={<ResetPasswordPage />} />
		<Route path="/password-reset" element={<ResetPasswordPage />} />
		<Route path="/forgot-password" element={<ForgotPasswordPage />} />
		<Route path="/" element={<Dashboard />} />
		</Routes>
		</div>):(
		<div className="content" ref={scrollRef} style={isMobile ? ({
			'--sidebar-width': '0px',
			'--page-gutter': '14px',
			position: 'fixed',
			inset: 0,
			width: '100%',
			height: '100dvh',
			minWidth: 0,
			transform: 'none',
			overflowX: 'hidden',
			overflowY: 'auto',
			WebkitOverflowScrolling: 'touch',
			textAlign: 'center',
			boxSizing: 'border-box'
		}) : isSidebarVisible ? ({
			'--sidebar-width': `${sidebarWidth}px`,
			'--page-gutter': '3.5%',
			height: "100vh",
			alignItems: "center",
			justifyContent: "center",
			textAlign: "center",
			left: `${sidebarWidth}px`,
			top: '0px',
			right: `-${sidebarWidth}px`,
			position: 'fixed',
			transition: 'right 0.3s ease-in-out', // Adjusted transition property
			transform: 'translateX(0)',
			overflow: "auto"
		  }
		) : ({
			'--sidebar-width': `${sidebarWidth}px`,
			'--page-gutter': '3.5%',
			height: "100vh",
			alignItems: "center",
			justifyContent: "center",
			textAlign: "center",
			left: `${sidebarWidth}px`,
			top: '0px',
			right: `-${sidebarWidth * 2}px`,
			position: 'fixed',
			transition: 'right 0.3s ease-in-out', // Adjusted transition property
			transform: `translateX(-${sidebarWidth}px)`,
			overflow: "auto"
		  })}>
		
      <Routes>
		<Route path="/SignIn" element={<SignInPage />} />
		<Route path="/SignUp" element={<SignUpPage />} />
		<Route path="/ForgotPassword" element={<ForgotPasswordPage />} />
		<Route path="/ResetPassword" element={<ResetPasswordPage />} />
		<Route path="/reset-password" element={<ResetPasswordPage />} />
		<Route path="/password-reset" element={<ResetPasswordPage />} />
		<Route path="/forgot-password" element={<ForgotPasswordPage />} />
		<Route path="/charts" element={<Charts />} />
		<Route path="/BuyStocks" element={<StockPurchase />} />
		<Route path="/Portfolio" element={!authReady ? null : isLoggedIn ? <PortfolioDisplayPage authReady={authReady} /> : <SignedOutFeature feature="your portfolio" />} />
		<Route path="/OrderHistory" element={!authReady ? null : isLoggedIn ? <OrderHistory /> : <SignedOutFeature feature="order history" />} />
		<Route path="/Account" element={!authReady ? null : isLoggedIn ? <AccountPage /> : <SignedOutFeature feature="account settings" />} />
		<Route path="/Settings" element={!authReady ? null : isLoggedIn ? <Settings /> : <SignedOutFeature feature="settings" />} />
    <Route path="/stock/:ticker" element={<StockPageWrapper scrollRootRef={scrollRef} />} />
		<Route path="/" element={<Dashboard />} />
		<Route path="/dashboard" element={<Dashboard />} />
		<Route path="/scanner" element={!authReady ? null : isLoggedIn ? <Scanner /> : <SignedOutFeature feature="the stock scanner" />} />
		<Route path="/Statki" element={<Battleship />} />
		<Route path="/search/:query" element={<SearchResults />} />
		<Route path="/test" element={<Test />} />
		<Route path="/Tournaments" element={<Tournaments />} />
    <Route
      path="/lab"
      element={
        isMobile ? (
          <main className="mobileDesktopOnlyPage">
            <div className="mobileDesktopOnlyCard">
              <div className="mobileDesktopOnlyIcon" aria-hidden="true">↗</div>
              <h1>Lab works best on desktop</h1>
              <p>
                The strategy builder needs a larger workspace. Open StockSleuth on
                a desktop or laptop to use Lab.
              </p>
              <button type="button" onClick={() => navigate("/dashboard")}>
                Back to dashboard
              </button>
            </div>
          </main>
        ) : (
          !authReady ? null : isLoggedIn ? <Lab /> : <SignedOutFeature feature="the strategy Lab" />
        )
      }
    />
		<Route path="/swipe" element={!authReady ? null : isLoggedIn ? <Swiping /> : <SignedOutFeature feature="Stock Swipe" />} />
		<Route path="/profile/:username" element={<ProfilePage />} />
		<Route path="/:articleUrl" element={<Articles />} />
		<Route path="/privacy" element={<PrivacyPolicy />} />
		<Route path="/terms" element={<TermsOfService />} />
		<Route path="/cookies" element={<CookiePolicy />} />
		<Route path="/ai-transparency" element={<AiTransparency />} />
		<Route path="/learn" element={<Learn />} />
		<Route path="/courses/:courseId/:lessonId?" element={<CoursePage />} />
      </Routes>
	  
	  
		</div>)}
	  
	  </div>
	</div>
	
	
  );
}

export default App;





